import React, { useEffect, useRef } from "react"
import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Chip,
  Fab,
  TextField,
  InputAdornment,
} from "@mui/material"
import { Add, Search } from "@mui/icons-material"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import AddMarketItemModal from "../Modals/AddMarketItemModal/AddMarketItemModal"
import { useApiService } from "../hooks/Api/useApiService"
import UserSection from "./UserSection/UserSection"

const statusColor = {
  New: "success",
  Used: "warning",
}

const Marketplace = () => {
  const [items, setItems] = React.useState([])
  const { getData, postData } = useApiService()

  useEffect(() => {
    getData("sharie/getmarketitems").then((data) => {
      setItems(data.items || [])
    })
  }, [])

  const t = useTranslationSharie()
  const add_itemRef = useRef()

  const handleClickAddItem = () => {
    if (add_itemRef.current) {
      add_itemRef.current.childFunction()
    }
  }
  const handleSearchItem = (event) => {
    if (event.target.value === "") {
      getData("sharie/getmarketitems").then((data) => {
        setItems(data?.items || [])
      })
    }
    postData("sharie/searchmarketitems", { query: event.target.value }).then((data) => {
      setItems(data?.items || [])
    })
  }

  return (
    <T>
      <AddMarketItemModal ref={add_itemRef} />

      <Box sx={{ p: 3, bgcolor: "background.paper", minHeight: "100vh" }}>
        {/* Search Bar */}
        <Box sx={{ mb: 3, maxWidth: 400 }}>
          <TextField
            fullWidth
            placeholder={t("Search items...")}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <Search color='primary' />
                </InputAdornment>
              ),
            }}
            variant='outlined'
            onChange={handleSearchItem}
          />
        </Box>

        {/* Grid of Items */}
        <Grid container spacing={3}>
          {items.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.id}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 3,
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "scale(1.02)",
                  },
                }}
              >
                <CardMedia component='img' height='200' image={item.image} alt={item.title} />
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography variant='h6' fontWeight='bold' color='primary'>
                      {item.title}
                    </Typography>
                    <Chip
                      label={t(item.status)}
                      color={statusColor[item.status] || "default"}
                      size='small'
                    />
                  </Box>
                  <Typography variant='body2' sx={{ mb: 1 }}>
                    {item.description}
                  </Typography>
                  <Typography variant='subtitle1' color='secondary'>
                    {item.payment} - {item.price.toLocaleString()}
                  </Typography>
                </CardContent>
                <UserSection user={item.user} />
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Add Item Floating Button */}
        <Fab
          color='secondary'
          aria-label='add'
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            bgcolor: "purple",
            color: "text.primary",
            "&:hover": {
              bgcolor: "secondary.dark",
            },
          }}
          onClick={handleClickAddItem}
        >
          <Add />
        </Fab>
      </Box>
    </T>
  )
}

export default Marketplace
